import { render, staticRenderFns } from "./LoginBlock.vue?vue&type=template&id=77b8804c&scoped=true"
import script from "./LoginBlock.vue?vue&type=script&lang=js"
export * from "./LoginBlock.vue?vue&type=script&lang=js"
import style0 from "./LoginBlock.vue?vue&type=style&index=0&id=77b8804c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b8804c",
  null
  
)

export default component.exports